const Providers = {
    Google: 'google',
    Microsoft: 'microsoft',
    LinkedIn: 'linkedin',
    Email: 'email',
    EnterpriseSSO: 'enterprisesso',
};

export default Providers;
